import Footer from '@components/shared/Footer/Footer';
import IdentityFailedPage from '@components/shared/IdentityFailedPage/IdentityFailedPage';
import { useTexts } from 'utils/useTexts';

const IdentityFailed = () => {
  const { t } = useTexts();
  return (
    <>
      <IdentityFailedPage />

      <Footer text={t('identityFailed.footer')} />
    </>
  );
};

export default IdentityFailed;
